module.exports = __webpack_public_path__ + "img/hs3.cf261636.png";